import { Box, Stack, Typography } from '@mui/material';

import { EstateOnboardingSuggestionsButton } from '@/modules/estate/estateAIOnboarding/EstateOnboardingSuggestionsButton';
import { COLORS } from '@/styles/tokens/colors';

import { useTrustsBusinessesSuggestions } from '../hooks/useTrustsBusinessesSuggestions';
import { CreateTrustOrBusinessButton } from './CreateTrustOrBusinessButton';

export interface TrustsBusinessesEmptyStateProps {
  householdId: string;
  onAfterCreate: () => void;
}

/**
 * Shown when the household has no trusts or businesses to link data to, with
 * the two ways forward from the design: create one by hand, or review the AI's
 * suggestions on the Estate page.
 */
export function TrustsBusinessesEmptyState({
  householdId,
  onAfterCreate,
}: TrustsBusinessesEmptyStateProps) {
  const { totalCount, options } = useTrustsBusinessesSuggestions();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `solid 1px ${COLORS.GRAY[200]}`,
        borderRadius: '4px',
        minHeight: 400,
        p: 3,
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Box>
          <Typography variant="title-xs" component="p">
            No trusts or businesses
          </Typography>
          <Typography variant="body-s" color={COLORS.TEXT.SECONDARY}>
            This client has no trusts or businesses to link data to
          </Typography>
        </Box>

        <Stack direction="row" spacing={1} alignItems="center">
          <CreateTrustOrBusinessButton
            householdId={householdId}
            onAfterCreate={onAfterCreate}
          />
          {/* Renders nothing when there are no suggestions to review. */}
          <EstateOnboardingSuggestionsButton
            dataTestId="manage-integration-data-trusts-businesses-suggestions"
            suggestionOptions={options}
            totalCount={totalCount}
            size="sm"
          />
        </Stack>
      </Stack>
    </Box>
  );
}
